import ActionTypes from "./constants";
import { IEmojiReactionPayload } from "../types";

export const scheduleAddReaction = (reaction: IEmojiReactionPayload) => ({
  type: ActionTypes.SCHEDULE_ADD_REACTION,
  payload: { reaction },
});
